<template>

    <div class="container">

        <!-- 這裏是會被緩存的視圖組件 -->
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>

        <!-- 這裏是不被緩存的視圖組件 -->
        <router-view v-if="!$route.meta.keepAlive"></router-view>

        <div class=" bottom-container">

            <div @click="bookCityClick" class="bottom-item-container">
                <img id="book_city" src="../assets/img_book1.png" alt="" style="width:20% ">
                <span>書城</span>
            </div>

            <div @click="bookShelfClick" class="bottom-item-container">
                <img id="book_shelf" src="../assets/img_shujia.png" alt="" style="width:17% ">
                <span>書架</span>
            </div>

            <div @click="mineClick" class="bottom-item-container">
                <img id="mine" src="../assets/img_mine.png" alt="" style="width:17% ">
                <span>我的</span>
            </div>
        </div>
    </div>

</template>

<script>
import bookCityImage1 from "../assets/img_book.png";
import bookCityImage2 from "../assets/img_book1.png";
import bookShelfImage1 from "../assets/img_shujia.png";
import bookShelfImage2 from "../assets/img_shujia1.png";
import mineImage1 from "../assets/img_mine.png";
import mineImage2 from "../assets/img_mine1.png";

export default {
    name: "BottomNavVue",

    data() {
        return {
            bookCityIcon1: bookCityImage1,
            bookCityIcon2: bookCityImage2,
            bookShelfIcon1: bookShelfImage1,
            bookShelfIcon2: bookShelfImage2,
            mineIcon1: mineImage1,
            mineIcon2: mineImage2,
        };
    },

    methods: {
        //書城
        bookCityClick: function () {
            document.getElementById("book_city").src = this.bookCityIcon2;
            document.getElementById("book_shelf").src = this.bookShelfIcon1;
            document.getElementById("mine").src = this.mineIcon1;

            this.$router.push({
                path: "BookCityVue",
            });
        },

        //書架
        bookShelfClick: function () {
            document.getElementById("book_city").src = this.bookCityIcon1;
            document.getElementById("book_shelf").src = this.bookShelfIcon2;
            document.getElementById("mine").src = this.mineIcon1;

            this.$router.push({
                path: "BookShelfVue",
            });
        },

        //我的
        mineClick: function () {
            document.getElementById("book_city").src = this.bookCityIcon1;
            document.getElementById("book_shelf").src = this.bookShelfIcon1;
            document.getElementById("mine").src = this.mineIcon2;

            this.$router.push({
                path: "MineVue",
            });
        },
    },
};
</script>

<style scoped>
/*手機*/
@media screen and (max-width: 600px) {
    .bottom-container {
        width: 100%;
        height: 50px;
        position: fixed;
        bottom: 0;
        display: flex;
        flex-direction: row;
        background-color: floralwhite;
    }
}

/*平板*/
@media screen and (min-width: 600px) and (max-width: 960px) {
    .bottom-container {
        width: 480px;
        height: 50px;
        position: fixed;
        bottom: 0;
        display: flex;
        flex-direction: row;
        background-color: floralwhite;
    }
}

/*PC*/
@media screen and (min-width: 960px) {
    .bottom-container {
        width: 480px;
        height: 50px;
        position: fixed;
        bottom: 0;
        display: flex;
        flex-direction: row;
        background-color: floralwhite;
    }
}

.bottom-item-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 33%;
    text-align: center;
}

.bottom-item-container img {
    width: 20%;
}

.bottom-item-container span {
    color: #333333;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/BottomNavVue.vue